import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/pages/login/login-page';
import { safeAuthReturn } from '@/shared/lib/auth-return';

/** Where to navigate after a successful sign-in.  Constrained to same-origin
 *  paths (must start with '/') so we can't be tricked into opening an
 *  off-site URL via a crafted `?next=`. */
const loginSearch = z.object({
  next: z.unknown().transform((value) => safeAuthReturn(value)).optional(),
  email: z.string().email().max(320).optional().catch(undefined),
  /** Set by the GitHub OAuth callback when login didn't complete. */
  error: z.string().optional(),
  /** Set by the GitHub OAuth callback when local MFA must finish sign-in. */
  oauthStepUp: z.enum(['two_factor_required', 'enrollment_required']).optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  component: LoginPage,
  validateSearch: loginSearch,
});
